export default {
  head: {
    title: 'Wallet transfers list',
    action: {
      search: {
        tooltip: 'Search single operation by Operation Id'
      }
    }
  },
  footer: {
    label: 'Total cost',
    tooltip: 'Value from entire period'
  },
  dialog: {
    search: {
      title: 'Search Wallet transfer operation'
    },
    details: {
      title: 'Wallet transfer operation details'
    }
  }
};
